import { endpoints } from "@cayo/shared/services/endpoints.service";

export async function getProductState() {
  try {
    const response = await fetch(
      `${endpoints.publicUrl}/v0/settings/serverSubscriptions/getProductState`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      throw new Error(`${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`${error}`);
  }
}

export async function getProductSummary(url: string) {
  try {
    const response = await fetch(`${url}`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`${error}`);
  }
}
